module.exports = __webpack_public_path__ + "static/about-1-4e5d536162492272ffbc3841b74033a0.jpg";